import { ReportType, ReportResponse, GetReportResponse } from '../types'

export const generateReportResponse = (
    customReportId: string,
    type: ReportType
): ReportResponse => {
    const baseFilters = {
        nodeIds: [243189],
        providerIds: [7692],
        startDate: '2024-03-29',
        endDate: '2025-03-28',
    }

    const baseReportProps: GetReportResponse = {
        customReportId: customReportId,
        customerId: 1234567890,
        type,
        name:
            type === 'usage-cost'
                ? 'Usage & cost for 8573679484'
                : type === 'payables-summary'
                  ? 'Payables summary for 8573679484'
                  : type === 'interval-data'
                    ? 'Interval data for 8573679484'
                    : 'Benchmarking for 8573679484',
        owner: {
            userId: 'uuid v4',
            name: 'Demo account',
        },
        access: 'Everyone',
        filters: baseFilters,
        fields: [
            'date',
            'cost_commodity_totalCommodityCost',
            'cost_commodity_supply',
            'usage_commodityUsage',
        ],
        createdAt: '2025-01-01T00:00:00.000Z',
        updatedAt: '2025-01-01T00:00:00.000Z',
    }

    const typeSpecificConfig = {
        'usage-cost': {
            filters: {
                ...baseFilters,
                commodityTypeId: '1',
                contractIds: [232747],
                panIds: [0],
                tagIds: [1986],
                facilityIds: [127324],
                usnAccountIds: [201408],
            },
        },
        'payables-summary': {
            filters: {
                ...baseFilters,
                commodityTypeIds: [2],
                invoiceNumbers: undefined,
                contractIds: undefined,
                panIds: undefined,
                tagIds: [1982],
                facilityIds: [127326],
                usnAccountIds: [201829],
            },
            offset: 0,
            limit: 10,
            order: 'desc',
            sortBy: 'billDate',
        },
        benchmarking: {
            filters: {
                ...baseFilters,
                commodityTypeId: '1',
                contractIds: [232747],
                panIds: [0],
                tagIds: [1986],
                facilityIds: [127324],
                usnAccountIds: [201408],
                type: 'facility',
                trendType: 'average',
                comparisonPeriod: 'previousYear',
                applyWeatherNormalization: false,
                applySquareFootage: false,
                includeEmissions: false,
            },
        },
        'total-emissions': {
            filters: {
                nodeIds: [243189],
                startDate: '2024-03-29',
                endDate: '2025-03-28',
                commodityTypeIds: ['1'],
                contractIds: [232747],
                tagIds: [1986],
                facilityIds: [127324],
                type: 'commodities',
                scope: 'scope2',
                scope2type: 'marketBased',
            },
        },
        'ghg-emissions': {
            filters: {
                nodeIds: [243189],
                startDate: '2024-03-29',
                endDate: '2025-03-28',
                commodityTypeIds: ['1'],
                contractIds: [232747],
                tagIds: [1986],
                facilityIds: [127324],
                scope: 'scope2',
                scope2type: 'marketBased',
                showTotals: true,
            },
        },
        'interval-data': {
            filters: {
                nodeIds: [243189],
                startDate: '2024-03-29',
                endDate: '2025-03-28',
                type: 'utilityData',
                timeInterval: 'oneHour',
                timezone: 'Central Standard Time',
                dataGrouping: 'aggregate',
                dataType: 'demandAverage',
            },
        },
    }

    return {
        ...baseReportProps,
        type,
        ...typeSpecificConfig[type],
    } as ReportResponse
}
